import script from "./QueueTicketItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueTicketItem.vue?vue&type=script&setup=true&lang=ts"

import "./QueueTicketItem.vue?vue&type=style&index=0&id=3bf8e0e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf8e0e6"]])

export default __exports__